import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveBottomIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2324 15.4648L0.880279 15.4648C0.456341 15.4648 0.112671 15.8085 0.112671 16.2325C0.112671 16.6564 0.456341 17.0001 0.880279 17.0001L16.2324 17.0001C16.6564 17.0001 17 16.6564 17 16.2325C17 15.8085 16.6564 15.4648 16.2324 15.4648Z" fill={props.fillColor ?? "#424C57"}/>
      <path d="M10.8592 0.113281L6.25358 0.113281C5.61768 0.113281 5.10217 0.628786 5.10217 1.26469L5.10217 12.7788C5.10217 13.4147 5.61768 13.9302 6.25358 13.9302L10.8592 13.9302C11.4951 13.9302 12.0106 13.4147 12.0106 12.7788L12.0106 1.26469C12.0106 0.628786 11.4951 0.113281 10.8592 0.113281Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>
  )
}

export default MoveBottomIcon;
